"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _document = babelHelpers.interopRequireDefault(require("./document"));

var _decorators = require("decorators");

var _class, _descriptor, _temp;

var SubmissionDocumentCard = (_class = (_temp =
/*#__PURE__*/
function (_DocumentCard) {
  babelHelpers.inherits(SubmissionDocumentCard, _DocumentCard);

  function SubmissionDocumentCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, SubmissionDocumentCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(SubmissionDocumentCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "feedbackCount", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(SubmissionDocumentCard, [{
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) return babelHelpers.get(babelHelpers.getPrototypeOf(SubmissionDocumentCard.prototype), "renderBottomContent", this).call(this);
      var r = babelHelpers.get(babelHelpers.getPrototypeOf(SubmissionDocumentCard.prototype), "renderBottomContent", this).call(this);
      var fb = this.feedbackBadge(this.feedbackCount);

      if (r || fb) {
        if (r) {
          if (!Array.isArray(r)) r = [r];
        } else {
          r = [];
        }

        r.unshift(fb);
      }

      return r;
    }
  }]);
  return SubmissionDocumentCard;
}(_document.default), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "feedbackCount", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = SubmissionDocumentCard;